// import React from "react";
// import "./BookingModal.css";

// export default function BookingModal({ data, onClose }) {
//   if (!data) return null;

//   return (
//     <div className="booking-overlay">
//       <div className="booking-modal">

//         <button className="close-btn" onClick={onClose}>×</button>

//         <h2 className="modal-title">Complete Your Booking</h2>

//         {/* PREVIEW */}
//         <div className="room-preview">
//           <img src={data.bimg || data.aimg || data.img} alt={data.title} />

//           <div className="room-details">
//             <h3>{data.title}</h3>
//             <p className="price">{data.price} {data.price ? <span>/ night</span> : null}</p>

//             <ul>
//               {data.size && <li><b>Size:</b> {data.size}</li>}
//               {data.capacity && <li><b>Capacity:</b> {data.capacity}</li>}
//               {data.bed && <li><b>Bed:</b> {data.bed}</li>}
//               {data.services && <li><b>Services:</b> {data.services}</li>}
//             </ul>
//           </div>
//         </div>

//         {/* BOOKING FORM */}
//         <form className="booking-form">
//           <div className="input-group">
//             <input type="text" placeholder="Full Name" required />
//             <input type="email" placeholder="Email Address" required />
//           </div>

//           <div className="input-group">
//             <input type="tel" placeholder="Mobile Number" required />
//             <select required>
//               <option value="">Guests</option>
//               <option>1</option>
//               <option>2</option>
//               <option>3</option>
//               <option>4+</option>
//             </select>
//           </div>

//           <div className="input-group">
//             <input type="date" required />
//             <input type="date" required />
//           </div>

//           <textarea placeholder="Special Requests (optional)"></textarea>

//           <button className="final-booking-btn" type="submit">
//             Confirm & Book Now
//           </button>
//         </form>

//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import "./BookingModal.css";

// export default function BookingModal({ data, onClose }) {
//   const [loading, setLoading] = useState(false);

//   if (!data) return null;

//   const handlePayment = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // Extract numeric price (e.g., from "₹1500" to 1500)
//       const amount = parseInt(data.price.replace(/[^0-9]/g, ""));

//       // 1. Create order on your backend
//       const orderResponse = await fetch("http://localhost:5000/create-order", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ amount, currency: "INR" }),
//       });

//       const orderData = await orderResponse.json();

//       if (!orderData.success) throw new Error("Order creation failed");

//       // 2. Initialize Razorpay Checkout
//       const options = {
//         key: orderData.key_id,
//         amount: orderData.order.amount,
//         currency: orderData.order.currency,
//         name: "Hotel Prem Vatika",
//         description: `Booking for ${data.title}`,
//         order_id: orderData.order.id,
//         handler: async function (response) {
//           // 3. Verify payment on your backend
//           const verifyResponse = await fetch("http://localhost:5000/verify-payment", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             }),
//           });

//           const verifyData = await verifyResponse.json();
//           if (verifyData.success) {
//             alert("Booking & Payment Successful!");
//             onClose();
//           } else {
//             alert("Payment verification failed.");
//           }
//         },
//         prefill: {
//           name: e.target[0].value,
//           email: e.target[1].value,
//           contact: e.target[2].value,
//         },
//         theme: { color: "#3399cc" },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (error) {
//       console.error("Payment Error:", error);
//       alert("Something went wrong with the payment.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="booking-overlay">
//       <div className="booking-modal">
//         <button className="close-btn" onClick={onClose}>×</button>

//         <h2 className="modal-title">Complete Your Booking</h2>

//         {/* PREVIEW */}
//         <div className="room-preview">
//           <img src={data.bimg || data.aimg || data.img} alt={data.title} />

//           <div className="room-details">
//             <h3>{data.title}</h3>
//             <p className="price">{data.price} {data.price ? <span>/ night</span> : null}</p>

//             <ul>
//               {data.size && <li><b>Size:</b> {data.size}</li>}
//               {data.capacity && <li><b>Capacity:</b> {data.capacity}</li>}
//               {data.bed && <li><b>Bed:</b> {data.bed}</li>}
//               {data.services && <li><b>Services:</b> {data.services}</li>}
//             </ul>
//           </div>
//         </div>

//         {/* BOOKING FORM - Added onSubmit handler */}
//         <form className="booking-form" onSubmit={handlePayment}>
//           <div className="input-group">
//             <input type="text" placeholder="Full Name" required />
//             <input type="email" placeholder="Email Address" required />
//           </div>

//           <div className="input-group">
//             <input type="tel" placeholder="Mobile Number" required />
//             <select required>
//               <option value="">Guests</option>
//               <option value="1">1</option>
//               <option value="2">2</option>
//               <option value="3">3</option>
//               <option value="4">4+</option>
//             </select>
//           </div>

//           <div className="input-group">
//             <input type="date" required />
//             <input type="date" required />
//           </div>

//           <textarea placeholder="Special Requests (optional)"></textarea>

//           {/* Button shows loading state when processing payment */}
//           <button className="final-booking-btn" type="submit" disabled={loading}>
//             {loading ? "Processing..." : "Confirm & Pay Now"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

import React, { useState, useMemo, useEffect } from "react";
import "./BookingModal.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function BookingModal({ data, onClose }) {
  const [loading, setLoading] = useState(false);

  // State for dates to calculate dynamic pricing
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  // 🔴 NEW — Booked dates from DB
  const [blockedDates, setBlockedDates] = useState([]);
  // Get today's date in YYYY-MM-DD format for the 'min' attribute
  // const today = new Date().toISOString().split("T")[0];

  // Helper to format date to YYYY-MM-DD for API
  const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  // 🔴 NEW
  const [dateError, setDateError] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
// "success" | "failed" | "cancelled" | null

  const API_BASE = "https://prem-vatika.onrender.com"; //http://localhost:5000 // change after deployment
  // 🔴 NEW — Fetch blocked dates for this room
  useEffect(() => {
    if (!data?.roomId) return;

    fetch(`${API_BASE}/booked/${data.roomId}`)
      .then((res) => res.json())
      .then((res) => setBlockedDates(res))
      .catch(console.error);
  }, [data]);

  // 🔴 NEW — Check if date is blocked
  const isBlocked = (date) => {
    return blockedDates.some((b) => {
      const d = new Date(date);
      return d >= new Date(b.checkIn) && d < new Date(b.checkOut);
    });
  };
  // Calculate dynamic price based on number of nights
  const totalAmount = useMemo(() => {
    if (!data || !data.price) return 0;
    const basePrice = parseInt(data.price.replace(/[^0-9]/g, ""));

    if (!checkIn || !checkOut) return basePrice;

    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const diffTime = end - start;
    const diffNights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Ensure at least 1 night is charged if checkout is same day or invalid
    return diffNights > 0 ? basePrice * diffNights : basePrice;
  }, [checkIn, checkOut, data]);

  if (!data) return null;

  const handlePayment = async (e) => {
    e.preventDefault();

     // Always reset loading first
      setLoading(false);
    if (!checkIn || !checkOut) {
      alert("Please select check-in and check-out dates");
      return;
    }

    if (checkIn === checkOut) {
  alert("Check-out must be after check-in");
  return;
}


    // setLoading(true);

    const rangeHasBlocked = (start, end) => {
      let d = new Date(start);
      const e = new Date(end);
      while (d < e) {
        if (isBlocked(formatDateLocal(d))) return true;
        d.setDate(d.getDate() + 1);
      }
      return false;
    };

    if (rangeHasBlocked(checkIn, checkOut)) {
      alert("Your selected dates include already booked days");
      return;
    }
  setShowConfirm(true);
  //pause here to test 
  // try {
  //     const formData = new FormData(e.target);

  //     const orderRes = await fetch(`${API_BASE}/create-order`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         amount: totalAmount,
  //         currency: "INR",
  //       }),
  //     });

  //     const orderData = await orderRes.json();
  //     if (!orderData.success) throw new Error("Order creation failed");

  //     const options = {
  //       key: orderData.key_id,
  //       amount: orderData.order.amount,
  //       currency: "INR" || orderData.order.currency,
  //       name: "Hotel Prem Vatika",
  //       description: `Booking: ${data.title}  (${checkIn} to ${checkOut})  roomId: ${data.roomId}`,
  //       order_id: orderData.order.id,

  //       handler: async function (response) {
  //         const verifyRes = await fetch(`${API_BASE}/verify-payment`, {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({
  //             ...response,
  //             roomId: data.roomId,
  //             checkIn,
  //             checkOut,
  //           }),
  //         });

  //         const verifyData = await verifyRes.json();

  //         if (verifyData.success) {
  //           alert("Booking & Payment Successful!");
  //           onClose();
  //         } else {
  //           alert("Payment Verification Failed");
  //         }

  //         setLoading(false);
  //       },

  //       modal: {
  //         ondismiss: function () {
  //           setLoading(false);
  //           alert("Payment Cancelled");
  //         },
  //         theme: { color: "#3399cc" },
  //       },

  //       prefill: {
  //         name: formData.get("name"),
  //         email: formData.get("email"),
  //         contact: formData.get("phone"),
  //       },

  //       theme: { color: "#3399cc" },
  //     };

  //     const rzp = new window.Razorpay(options);
  //     rzp.open();
  //   } catch (error) {
   //   alert("Error: " + error.message);
    //  setLoading(false);
    //}
  };

  //adding my function 

// const startPayment = async () => {
//   try {
//     setLoading(true);

//     const orderRes = await fetch(`${API_BASE}/create-order`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         amount: totalAmount,
//         currency: "INR",
//       }),
//     });

//     const orderData = await orderRes.json();
//     if (!orderData.success) throw new Error("Order creation failed");

//     const options = {
//       key: orderData.key_id,
//       amount: orderData.order.amount,
//       currency: orderData.order.currency,
//       name: "Hotel Prem Vatika",
//       description: `Booking: ${data.title} (${checkIn} to ${checkOut}) roomId: ${data.roomId}`,
//       order_id: orderData.order.id,

//       handler: async function (response) {
//         const verifyRes = await fetch(`${API_BASE}/verify-payment`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             ...response,
//             roomId: data.roomId,
//             checkIn,
//             checkOut,
//           }),
//         });

//         const verifyData = await verifyRes.json();

//         if (verifyData.success) {
//           alert("Booking & Payment Successful!");
//           onClose();
//         } else {
//           alert("Payment Verification Failed");
//         }

//         setLoading(false);
//       },

//       modal: {
//         ondismiss: function () {
//           setLoading(false);
//           alert("Payment Cancelled");
//         },
//       },

//       theme: { color: "#3399cc" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (error) {
//     alert("Error: " + error.message);
//     setLoading(false);
//   }
// };


const proceedPayment = async () => {
  setShowConfirm(false);
  setLoading(true);

  try {
    const orderRes = await fetch(`${API_BASE}/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: totalAmount,
        currency: "INR",
      }),
    });

    const orderData = await orderRes.json();
    if (!orderData.success) throw new Error("Order creation failed");

    const options = {
      key: orderData.key_id,
      amount: orderData.order.amount,
      currency: "INR",
      name: "Hotel Prem Vatika",
      description: `Booking: ${data.title} (${checkIn} to ${checkOut})`,
      order_id: orderData.order.id,

      handler: async function (response) {
        const verifyRes = await fetch(`${API_BASE}/verify-payment`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...response,
            roomId: data.roomId,
            checkIn,
            checkOut,
          }),
        });

        const verifyData = await verifyRes.json();

       if (verifyData.success) {
  setPaymentStatus("success");
  setTimeout(() => {
    onClose();
  }, 3000);
} else {
  setPaymentStatus("failed");
}

        setLoading(false);
      },

   modal: {
   ondismiss: function () {
    setLoading(false);
    setPaymentStatus("cancelled");
  },
},

      theme: { color: "#cfa670" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  rzp.on("payment.failed", function () {
  setLoading(false);
  setPaymentStatus("failed");
});
    
  } catch (error) {
    alert("Error: " + error.message);
    setLoading(false);
  }
};
  // const blockedRanges = blockedDates.map((b) => ({
  //   start: new Date(b.checkIn),
  //   end: new Date(b.checkOut),
  // }));

  // const isBlockedDay = (date) =>
  //   blockedRanges.some((r) => date >= r.start && date < r.end);
const isBlockedDay = (date) => {
  return blockedDates.some((booking) => {
    const start = new Date(booking.checkIn);
    const end = new Date(booking.checkOut);

    // Normalize all to midnight local
    start.setHours(0,0,0,0);
    end.setHours(0,0,0,0);

    const current = new Date(date);
    current.setHours(0,0,0,0);

    return current >= start && current < end;
  });
};

  const closePopup = () => {
  setPaymentStatus(null);
};
  return (
    <div className="booking-overlay"> 
      <div className="booking-modal">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <h2 className="modal-title">Complete Your Booking</h2>

        <div className="room-preview">
          <img src={data.bimg || data.aimg || data.img} alt={data.title} />
          <div className="room-details">
            <h3>{data.title}</h3>
            {/* Show dynamic total price */}
            <p className="price">
              ₹{totalAmount} <span>Total for stay</span>
            </p>
          </div>
        </div>

        <form className="booking-form" onSubmit={handlePayment}>
          <div className="input-group">
            <input type="text" name="name" placeholder="Full Name" required />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
            />
          </div>

          <div className="input-group">
            <input
              type="tel"
              name="phone"
              placeholder="Mobile Number"
              required
            />
            <select required>
              <option value="1">1 Guest</option>
              <option value="2">2 Guests</option>
              <option value="3">3 Guests</option>
            </select>
          </div>

          {/* Date Row */}
          <div className="date-row">
            <DatePicker
              selected={checkIn ? new Date(checkIn) : null}
              onChange={(date) => setCheckIn(formatDateLocal(date))}
              minDate={new Date()}
              filterDate={(date) => !isBlockedDay(date)}
              placeholderText="Check In"
              dayClassName={(date) =>
                isBlockedDay(date) ? "blocked-day" : undefined
              }
            />

            <DatePicker
              selected={checkOut ? new Date(checkOut) : null}
              onChange={(date) => setCheckOut(formatDateLocal(date))}
              minDate={checkIn ? new Date(checkIn) : new Date()}
              filterDate={(date) => !isBlockedDay(date)}
              placeholderText="Check Out"
              dayClassName={(date) =>
                isBlockedDay(date) ? "blocked-day" : undefined
              }
            />
          </div>

          {dateError && <p className="date-error">{dateError}</p>}

          <button
            className="final-booking-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? "Processing..." : `Pay ₹${totalAmount} & Book Now`}
          </button>
        </form>
      </div>
      {showConfirm && (
  <div className="premium-confirm-overlay">
    <div className="premium-confirm-box">
      <h3>Important Notice</h3>
      <p>
        Once the payment is successfully completed, this booking is 
        <strong> non-refundable </strong> and cannot be cancelled or modified.
      </p>
      <p className="confirm-sub">
        Please review your selected dates carefully before proceeding.
      </p>

      <div className="confirm-actions">
        <button
          className="cancel-btn"
          onClick={() => setShowConfirm(false)}
        >
          Cancel
        </button>
        <button
          className="confirm-btn"
          onClick={proceedPayment}
        >
          Confirm & Pay ₹{totalAmount}
        </button>
      </div>
    </div>
  </div>
)}

{paymentStatus && (
  <div className="premium-popup-overlay" onClick={closePopup}>
    <div
      className="premium-popup"
      onClick={(e) => e.stopPropagation()}
    >
      <button className="popup-close" onClick={closePopup}>
        ×
      </button>

      {paymentStatus === "success" && (
        <>
          <h2>Booking Confirmed ✨</h2>
          <p>
            Thank you for choosing <b>Prem Vatika</b>.
            Your reservation has been successfully confirmed.
          </p>
        </>
      )}

      {paymentStatus === "failed" && (
        <>
          <h2>Payment Failed</h2>
          <p>Please try again. No amount was deducted.</p>
        </>
      )}

      {paymentStatus === "cancelled" && (
        <>
          <h2>Payment Cancelled</h2>
          <p>Your booking was not completed.</p>
        </>
      )}

      <button className="popup-btn" onClick={closePopup}>
        Close
      </button>
    </div>
  </div>
)}
    </div>
  );
}
